export const POLL_STATES = {
  hide: "hide",
  showQuestion: "showQuestion",
  showResult: "showResult",
};
